var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankalogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 271,
    viewBox: "0 0 301 271",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.619 157.71C206.517 203.749 305.478 231.126 347.874 241.274C329.985 257.62 310.902 271.264 291.412 282.073C252.049 266.999 178.581 234.077 148.718 213.962C118.143 193.371 99.7353 161.279 94.2543 132.945C87.2715 96.926 98.2571 67.0435 111.339 45.8917C111.366 45.8636 111.38 45.8497 111.393 45.8356C119.808 34.393 129.224 23.2713 139.628 12.623C140.108 12.1326 140.573 11.6562 141.039 11.1798C139.156 13.7228 76.9046 98.8745 149.619 157.71Z",
    fill: "url(#paint0_linear_214_511)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.193 196C145.733 240.87 218.2 277.171 261.571 296.243C235.304 306.756 208.949 312.089 184.289 311.904C151.565 291.157 113.904 265.231 96.0502 248.635C95.392 248.019 94.7339 247.403 94.1034 246.787C67.7783 221.201 57.1343 183.631 64.5034 147.668C70.8889 116.495 84.8107 84.1684 105.736 53.7276C89.6313 79.375 57.9467 143.699 105.193 196Z",
    fill: "url(#paint1_linear_214_511)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M195.713 111.546C218.898 124.397 247.032 133.92 275.594 140.959C329.524 154.271 384.945 158.769 411.309 160.237C401.656 178.357 389.602 196.131 375.224 212.976C341.678 208.599 229.227 182.666 191.146 163.422C165.256 150.34 141.804 128.793 131.337 101.75C126.782 90.0137 125.155 78.6457 125.556 67.8637C125.556 67.8637 124.654 11.4388 178.373 -23.4402C179.417 -24.1726 180.314 -24.4739 180.713 -24.6586C174.25 -15.7459 116.703 67.7307 195.712 111.519L195.713 111.546Z",
    fill: "url(#paint2_linear_214_511)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_214_511",
    x1: 242.543,
    y1: 222.188,
    x2: 213.481,
    y2: -13.8919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E3E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_214_511",
    x1: 191.303,
    y1: 252.695,
    x2: 150.162,
    y2: 29.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E3E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_214_511",
    x1: 291.534,
    y1: 171.633,
    x2: 244.697,
    y2: -74.0263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E3E3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankalogo);
export default __webpack_public_path__ + "static/media/Bankalogo.885cd36833e919913c64734cd13de090.svg";
export { ForwardRef as ReactComponent };